import { PostcodeLookUp, ValidationModel } from '../models/postcode-look-up.model';
import { VehicleData } from '../models/vehicle-data.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LookUpServiceAndValidation {
    constructor(private http: HttpClient) { }

    getAddresses(postcode: string): Observable<PostcodeLookUp> {
        return this.http.get<PostcodeLookUp>(`postcodelookup/${postcode}`);
    }

    getVehicleDetails(vrm: string): Observable<VehicleData> {
        return this.http.get<VehicleData>(`vehicledata/${vrm}`);
    }

    checkTelephone(tel: string): Observable<ValidationModel> {
        return this.http.get<ValidationModel>(`contactvalidation/phone/${tel}`);
    }

    checkEmail(email: string): Observable<ValidationModel> {
        return this.http.get<ValidationModel>(`contactvalidation/email/${email}`);
    }
}
